export const storageProvider = require('./localforage');



/** WEBPACK FOOTER **
 ** ./src/lib/storage/provider/provider.js
 **/